// extracted by mini-css-extract-plugin
export default {"root":"NavigationButton_root__ytrp+","icon":"NavigationButton_icon__zz534","selected":"NavigationButton_selected__HdTVj"};